module.exports = __webpack_public_path__ + "img/103.0c84fd60.svg";